module.exports = __webpack_public_path__ + "img/max-file-deny--json.82b06e26.svg";